'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function camelToSpaceCase(str) {
  return str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
}
function styleObjectToString(style) {
  return Object.entries(style).map(_ref => {
    let [key, value] = _ref;
    const cssKey = camelToSpaceCase(key);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `${cssKey}:${value}`;
  }).join(';');
}
const StyledDocumentBody = () => {
  const {
    documentbodyNoneNone: bodyStyle
  } = nthHookTheme.useTheme();
  React.useEffect(() => {
    if (!bodyStyle) return;
    const styleString = styleObjectToString(bodyStyle);
    const styleElement = document.createElement('style');
    styleElement.innerHTML = `body{${styleString}}`;
    document.head.appendChild(styleElement);
  }, [bodyStyle]);
  return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null);
};
var index = nthHookTheme.withThemeProvider(StyledDocumentBody, {
  themeTokens: ['documentbodyNoneNone']
});

exports["default"] = index;
